export default __webpack_public_path__ + "static/media/Twitter.3c2fc761.svg";